module.exports = __webpack_public_path__ + "static/media/Desktop_Skills_19.67c38714.png";